const roleUrls = {
    fetchLevels: {
        url: '/levels'
    },
    fetchLevel: {
        url: '/levels/:id'
    },
    fetchFormOptions: {
        url: '/levels/actions/formOptions'
    },

};

export default roleUrls;
